import _ from 'lodash'
interface IMaxLengthConfig {
    maxLength: number
    errorMsg: string
}

export function asyncValidateMaxLength(config: IMaxLengthConfig) {
    return function validateMaxLength(rule, value, callback) {
        const {
            maxLength,
            errorMsg
        } = config
        value = _.trim(value)
        if (_.size(value) <= maxLength) {
            callback()
        } else {
            callback(new Error(errorMsg))
        }
    }
}
